(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horeca-before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* Support multiple instances on the same page */
    document.querySelectorAll('[id^="horeca-ba-slider-"]').forEach(function (slider) {
      var sec      = slider.id.replace('horeca-ba-slider-', '');
      var bar      = document.getElementById('horeca-ba-bar-'   + sec);
      var afterWrap = document.getElementById('horeca-ba-after-' + sec);
      if (!bar || !afterWrap) return;

      var dragging   = false;
      var currentPos = 50;

      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        currentPos = pct;
        bar.style.left            = pct + '%';
        afterWrap.style.width     = (100 - pct) + '%';
        slider.setAttribute('aria-valuenow', Math.round(pct));
      }

      function posFromX(clientX) {
        var rect = slider.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      /* Mouse */
      bar.addEventListener('mousedown', function (e) {
        dragging = true;
        e.preventDefault();
        slider.classList.add('is-interacted');
      });
      document.addEventListener('mouseup',   function () { dragging = false; });
      document.addEventListener('mousemove', function (e) {
        if (dragging) setPos(posFromX(e.clientX));
      });

      /* Touch */
      bar.addEventListener('touchstart', function (e) {
        dragging = true;
        slider.classList.add('is-interacted');
        e.preventDefault();
      }, { passive: false });
      document.addEventListener('touchend',   function () { dragging = false; });
      document.addEventListener('touchmove',  function (e) {
        if (dragging) setPos(posFromX(e.touches[0].clientX));
      }, { passive: true });

      /* Click anywhere on slider to jump */
      slider.addEventListener('click', function (e) {
        setPos(posFromX(e.clientX));
        slider.classList.add('is-interacted');
      });

      /* Keyboard — arrow keys for accessibility */
      slider.addEventListener('keydown', function (e) {
        slider.classList.add('is-interacted');
        if (e.key === 'ArrowLeft')  { setPos(currentPos - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setPos(currentPos + 5); e.preventDefault(); }
        if (e.key === 'Home')       { setPos(0);   e.preventDefault(); }
        if (e.key === 'End')        { setPos(100); e.preventDefault(); }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horeca-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var section = document.getElementById('horeca-faq');
    if (!section) return;

    var btns = section.querySelectorAll('.horeca-faq__question');

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen    = this.getAttribute('aria-expanded') === 'true';
        var answerId  = this.getAttribute('aria-controls');
        var answer    = document.getElementById(answerId);
        var item      = this.closest('.horeca-faq__item');

        /* Close all others */
        btns.forEach(function (other) {
          if (other !== btn) {
            other.setAttribute('aria-expanded', 'false');
            var otherId  = other.getAttribute('aria-controls');
            var otherAns = document.getElementById(otherId);
            var otherItem = other.closest('.horeca-faq__item');
            if (otherAns)  otherAns.classList.remove('is-open');
            if (otherItem) otherItem.classList.remove('is-open');
          }
        });

        /* Toggle current */
        this.setAttribute('aria-expanded', String(!isOpen));
        answer.classList.toggle('is-open', !isOpen);
        item.classList.toggle('is-open', !isOpen);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horeca-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* ── FILTER TABS ── */
    var filterBtns = document.querySelectorAll(
      '#horeca-gallery-{{ section.id }} .horeca-gallery__filter-btn'
    );
    var items = document.querySelectorAll(
      '#horeca-gallery-grid-{{ section.id }} .horeca-gallery__item'
    );

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.getAttribute('data-filter');

        filterBtns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        items.forEach(function (item) {
          if (filter === 'all' || item.getAttribute('data-tag') === filter) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      });
    });

    /* ── LIGHTBOX ── */
    var lb      = document.getElementById('horeca-gallery-lb-{{ section.id }}');
    var lbImg   = document.getElementById('horeca-gallery-lb-img-{{ section.id }}');
    var lbCap   = document.getElementById('horeca-gallery-lb-cap-{{ section.id }}');
    var lbClose = document.getElementById('horeca-gallery-lb-close-{{ section.id }}');

    if (!lb || !lbImg) return;

    function openLb(src, alt, caption) {
      lbImg.src = src;
      lbImg.alt = alt || '';
      if (lbCap) lbCap.textContent = caption || '';
      lb.classList.add('is-open');
      lb.focus();
      document.body.style.overflow = 'hidden';
    }

    function closeLb() {
      lb.classList.remove('is-open');
      lbImg.src = '';
      document.body.style.overflow = '';
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var src     = item.getAttribute('data-src');
        var alt     = item.querySelector('img') ? item.querySelector('img').alt : '';
        var caption = item.getAttribute('data-caption') || '';
        if (src) openLb(src, alt, caption);
      });
    });

    if (lbClose) lbClose.addEventListener('click', closeLb);

    lb.addEventListener('click', function (e) {
      if (e.target === lb) closeLb();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLb();
    });

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horeca-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  /* Ken-burns zoom triggers after first paint to avoid CLS */
  var hero = document.getElementById('horeca-hero');
  if (!hero) return;
  requestAnimationFrame(function () {
    setTimeout(function () { hero.classList.add('is-loaded'); }, 80);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horeca-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initCountdown(secId) {
    var timerEl = document.getElementById('horeca-oc-timer-' + secId);
    if (!timerEl) return;

    var endStr  = timerEl.getAttribute('data-end');
    var endDate = new Date(endStr).getTime();
    if (isNaN(endDate)) return;

    var daysEl = document.getElementById('horeca-oc-days-' + secId);
    var hrsEl  = document.getElementById('horeca-oc-hrs-'  + secId);
    var minEl  = document.getElementById('horeca-oc-min-'  + secId);
    var secEl  = document.getElementById('horeca-oc-sec-'  + secId);

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function tick() {
      var diff = endDate - Date.now();

      if (diff <= 0) {
        clearInterval(interval);
        timerEl.innerHTML = '<p class="horeca-oc__expired">This offer has ended.</p>';
        return;
      }

      var days = Math.floor(diff / 86400000);
      var hrs  = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000)  / 60000);
      var secs = Math.floor((diff % 60000)    / 1000);

      if (daysEl) daysEl.textContent = days;
      if (hrsEl)  hrsEl.textContent  = pad(hrs);
      if (minEl)  minEl.textContent  = pad(mins);
      if (secEl)  secEl.textContent  = pad(secs);
    }

    tick();
    var interval = setInterval(tick, 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    /* Find every countdown on the page — supports multiple section instances */
    document.querySelectorAll('[id^="horeca-oc-timer-"]').forEach(function (el) {
      var id = el.id.replace('horeca-oc-timer-', '');
      initCountdown(id);
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horeca-problem"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth >= 600) return;

    var grids = document.querySelectorAll('[id^="horeca-ps-grid-"]');

    grids.forEach(function (grid) {
      var secId    = grid.id.replace('horeca-ps-grid-', '');
      var dotsWrap = document.getElementById('horeca-ps-dots-' + secId);
      var cards    = grid.querySelectorAll('.horeca-ps__card');
      if (!dotsWrap || cards.length < 2) return;

      var dots = [];
      cards.forEach(function (_, i) {
        var btn = document.createElement('button');
        btn.className = 'horeca-ps__dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', 'Card ' + (i + 1));
        btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        btn.type = 'button';
        btn.addEventListener('click', function () {
          cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
        dots.push(btn);
        dotsWrap.appendChild(btn);
      });

      grid.addEventListener('scroll', function () {
        var idx = Math.round(grid.scrollLeft / (grid.offsetWidth * 0.85));
        idx = Math.max(0, Math.min(idx, dots.length - 1));
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
          d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
      }, { passive: true });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horeca-product-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  window.horecaAddToCart = function (btn, variantId) {
    if (!variantId || btn.disabled) return;

    var originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M12 2v20M2 12h20"/></svg> Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.status) {
        btn.innerHTML = 'Error — Try Again';
        btn.disabled = false;
        return;
      }
      btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg> Added!';
      btn.style.background = '#25d366';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(function () {
        btn.innerHTML = originalHTML;
        btn.style.background = '';
        btn.disabled = false;
      }, 2500);
    })
    .catch(function () {
      btn.innerHTML = 'Error — Try Again';
      btn.disabled = false;
    });
  };

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horeca-whyus"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth >= 600) return;

    var sectionEls = document.querySelectorAll('[id^="horeca-why-grid-"]');

    sectionEls.forEach(function (grid) {
      var secId   = grid.id.replace('horeca-why-grid-', '');
      var dotsWrap = document.getElementById('horeca-why-dots-' + secId);
      var cards    = grid.querySelectorAll('.horeca-why__card');
      if (!dotsWrap || cards.length < 2) return;

      var dots = [];
      cards.forEach(function (_, i) {
        var btn = document.createElement('button');
        btn.className = 'horeca-why__dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', 'Card ' + (i + 1));
        btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        btn.addEventListener('click', function () {
          cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
        dots.push(btn);
        dotsWrap.appendChild(btn);
      });

      grid.addEventListener('scroll', function () {
        var idx = Math.round(grid.scrollLeft / (grid.offsetWidth * 0.82));
        idx = Math.max(0, Math.min(idx, dots.length - 1));
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
          d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
      }, { passive: true });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgb-before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    var wrap    = document.getElementById('rgb-ba-slider');
    var clip    = document.getElementById('rgb-ba-after-clip');
    var divider = document.getElementById('rgb-ba-divider');
    var handle  = document.getElementById('rgb-ba-handle');
    var hint    = document.getElementById('rgb-ba-hint');

    if (!wrap || !clip || !divider) return;

    var pos = 50;          // current % position
    var dragging = false;
    var interacted = false;

    /* ── position update ── */
    function setPos(pct) {
      pos = Math.max(2, Math.min(98, pct));
      var p = pos.toFixed(2);
      clip.style.clipPath = 'inset(0 ' + (100 - pos).toFixed(2) + '% 0 0)';
      divider.style.left  = p + '%';
      handle.style.left   = p + '%';
      /* hide hint on first interaction */
      if (!interacted && hint) {
        interacted = true;
        hint.classList.add('is-hidden');
      }
    }

    /* ── coordinate → percentage ── */
    function toPercent(clientX) {
      var rect = wrap.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    /* ── MOUSE ── */
    wrap.addEventListener('mousedown', function (e) {
      dragging = true;
      wrap.classList.add('is-dragging');
      setPos(toPercent(e.clientX));
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      setPos(toPercent(e.clientX));
    });

    document.addEventListener('mouseup', function () {
      dragging = false;
      wrap.classList.remove('is-dragging');
    });

    /* ── TOUCH — drag anywhere on the image ── */
    wrap.addEventListener('touchstart', function (e) {
      dragging = true;
      wrap.classList.add('is-dragging');
      setPos(toPercent(e.touches[0].clientX));
    }, { passive: true });

    document.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      setPos(toPercent(e.touches[0].clientX));
    }, { passive: true });

    document.addEventListener('touchend', function () {
      dragging = false;
      wrap.classList.remove('is-dragging');
    });

    /* ── KEYBOARD (arrow keys) ── */
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { setPos(pos - 2); e.preventDefault(); }
      if (e.key === 'ArrowRight') { setPos(pos + 2); e.preventDefault(); }
      if (e.key === 'Home')       { setPos(0);        e.preventDefault(); }
      if (e.key === 'End')        { setPos(100);      e.preventDefault(); }
    });

    /* ── INTRO ANIMATION — auto-sweep once on first view ── */
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!reduceMotion) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || interacted) return;
        observer.disconnect();

        /* sweep left then back to center */
        var start = null;
        var DURATION = 1400; // ms

        function animate(ts) {
          if (!start) start = ts;
          var elapsed = ts - start;
          var t = Math.min(elapsed / DURATION, 1);
          /* ease: go to 25% then back to 50% */
          var eased = t < 0.5
            ? 2 * t * t
            : 1 - Math.pow(-2 * t + 2, 2) / 2;
          var target = t < 0.5
            ? 50 - (25 * eased * 2)   /* 50 → 25 */
            : 25 + (25 * (eased * 2 - 1)); /* 25 → 50 */
          setPos(target);
          if (t < 1 && !interacted) requestAnimationFrame(animate);
        }

        requestAnimationFrame(animate);
      }, { threshold: 0.4 });

      observer.observe(wrap);
    }

    /* ── SET INITIAL POSITION ── */
    setPos(50);

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgb-benefits-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Find every benefits section on the page */
  var sections = document.querySelectorAll('.cl-benefits');
  sections.forEach(function (section) {
    initSection(section);
  });

  function initSection(section) {
    var cards = section.querySelectorAll('[data-cl-animate]');

    /* [F6] Skip animations entirely if user prefers reduced motion */
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced) {
      cards.forEach(function (c) { c.classList.add('is-visible'); });
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          /* Read stagger delay from data attribute set in Liquid */
          var delay = parseInt(el.getAttribute('data-cl-delay') || '0', 10);
          setTimeout(function () { el.classList.add('is-visible'); }, delay);
          io.unobserve(el);
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      cards.forEach(function (c) { io.observe(c); });
    } else {
      /* Fallback: no IntersectionObserver support */
      cards.forEach(function (c) { c.classList.add('is-visible'); });
    }

    /* Lead form: prevent double-submit + optimistic UI */
    var form = section.querySelector('[data-cl-submit]');
    if (form) {
      form.closest('form').addEventListener('submit', function () {
        setTimeout(function () {
          form.textContent = '✓ Check your inbox!';
          form.disabled = true;
        }, 0);
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgb-hero-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var sliderEl = document.getElementById('hero-slider');
    if (!sliderEl) return;

    var INTERVAL = 5000;
    var progressFill = document.getElementById('hero-progress-fill');

    // Respect reduced motion preference
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var splide = new Splide('#hero-slider', {
      type: 'loop',
      autoplay: !reduceMotion,
      interval: INTERVAL,
      pauseOnHover: true,       // UX: let users read
      pauseOnFocus: true,       // A11y: pause when tabbing
      arrows: true,
      pagination: true,
      perPage: 1,
      perMove: 1,
      speed: 600,
      easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      breakpoints: {
        599: {
          arrows: false,
          pagination: true,
        },
      },
    });

    // Progress bar animation
    if (progressFill && !reduceMotion) {
      splide.on('autoplay:play', function () {
        progressFill.style.transition = 'width ' + INTERVAL + 'ms linear';
        progressFill.style.width = '100%';
      });

      splide.on('autoplay:pause', function () {
        progressFill.style.transition = 'none';
        progressFill.style.width = '0%';
      });

      splide.on('move', function () {
        progressFill.style.transition = 'none';
        progressFill.style.width = '0%';
        // Restart on next tick
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            progressFill.style.transition = 'width ' + INTERVAL + 'ms linear';
            progressFill.style.width = '100%';
          });
        });
      });
    }

    splide.mount();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgb-installation"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    var checkboxes = document.querySelectorAll('.install-step__check input[type="checkbox"]');
    var progressFill = document.getElementById('install-progress-fill');
    var progressText = document.getElementById('install-progress-text');
    var progressBar  = document.getElementById('install-progress-bar');
    var total = checkboxes.length;

    /* ── Checklist + progress bar ── */
    function updateProgress() {
      var done = 0;
      checkboxes.forEach(function (cb) {
        var step = cb.closest('.install-step');
        if (cb.checked) {
          done++;
          step.classList.add('is-done');
        } else {
          step.classList.remove('is-done');
        }
      });

      var pct = total > 0 ? Math.round((done / total) * 100) : 0;
      if (progressFill)  progressFill.style.width = pct + '%';
      if (progressText)  progressText.textContent = done + ' / ' + total + ' steps';
      if (progressBar) {
        progressBar.setAttribute('aria-valuenow', done);
      }

      /* All done — update CTA heading */
      if (done === total && total > 0) {
        var ctaHeading = document.querySelector('.install-cta-card__heading');
        if (ctaHeading) ctaHeading.textContent = '🎉 All steps complete — lights ready!';
      }
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', updateProgress);
    });

    /* ── Video: lazy load on click ── */
    var videoThumb = document.getElementById('install-video-thumb');
    var videoEmbed = document.getElementById('install-video-embed');
    var placeholder = document.getElementById('install-video-placeholder');

    if (videoThumb && videoEmbed && placeholder) {
      var videoUrl = placeholder.getAttribute('data-url') || '';

      function loadVideo() {
        if (!videoUrl) return;

        var embedUrl = videoUrl;

        // Convert standard YouTube URL to embed
        var ytMatch = videoUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/);
        if (ytMatch) {
          embedUrl = 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&rel=0';
        }

        var iframe = document.createElement('iframe');
        iframe.src = embedUrl;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.title = 'RGB LED strip light installation guide video';

        videoEmbed.innerHTML = '';
        videoEmbed.appendChild(iframe);
        videoThumb.style.display = 'none';
        videoEmbed.style.display = 'block';
      }

      videoThumb.addEventListener('click', loadVideo);
      videoThumb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          loadVideo();
        }
      });
    }

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgb-offers"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // Countdown timer — resets to a rolling 24h window each session
  // Uses sessionStorage so each new session gets a fresh 24h timer
  // (true urgency — not a fake static date)

  var wrap = document.getElementById('offers-countdown');
  if (!wrap) return;

  var KEY = 'chronos_offers_deadline';
  var DURATION = 24 * 60 * 60 * 1000; // 24 hours in ms

  var stored = sessionStorage.getItem(KEY);
  var deadline;

  if (stored) {
    deadline = parseInt(stored, 10);
    // If stored deadline has passed, set a new one
    if (deadline < Date.now()) {
      deadline = Date.now() + DURATION;
      sessionStorage.setItem(KEY, deadline);
    }
  } else {
    deadline = Date.now() + DURATION;
    sessionStorage.setItem(KEY, deadline);
  }

  var hoursEl = document.getElementById('cd-hours');
  var minsEl  = document.getElementById('cd-mins');
  var secsEl  = document.getElementById('cd-secs');

  if (!hoursEl || !minsEl || !secsEl) return;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function tick() {
    var remaining = Math.max(0, deadline - Date.now());
    var totalSecs = Math.floor(remaining / 1000);
    var h = Math.floor(totalSecs / 3600);
    var m = Math.floor((totalSecs % 3600) / 60);
    var s = totalSecs % 60;

    hoursEl.textContent = pad(h);
    minsEl.textContent  = pad(m);
    secsEl.textContent  = pad(s);

    if (remaining > 0) {
      requestAnimationFrame(function () {
        setTimeout(tick, 1000);
      });
    } else {
      // Timer expired — hide countdown gracefully
      wrap.style.display = 'none';
    }
  }

  tick();

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgb-product-cards"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Quick Add to Cart ── */
  window.rgbAddToCart = function (btn, variantId) {
    if (!variantId || btn.disabled) return;

    var originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M12 2v20M2 12h20"/></svg> Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.status) {
        btn.innerHTML = 'Error — Try Again';
        btn.disabled = false;
        return;
      }
      btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg> Added!';
      btn.style.background = '#25d366';

      /* Notify theme cart drawer / bubble if supported */
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      setTimeout(function () {
        btn.innerHTML = originalHTML;
        btn.style.background = '';
        btn.disabled = false;
      }, 2500);
    })
    .catch(function () {
      btn.innerHTML = 'Error — Try Again';
      btn.disabled = false;
    });
  };

  /* ── Filter tabs ── */
  document.addEventListener('DOMContentLoaded', function () {
    var filterBtns = document.querySelectorAll('.rgbcol-filter-btn');
    var cards = document.querySelectorAll('.rgbcol-card');

    if (!filterBtns.length || !cards.length) return;

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.getAttribute('data-filter');

        filterBtns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        cards.forEach(function (card) {
          if (filter === 'all') {
            card.style.display = '';
            return;
          }
          var tags = card.getAttribute('data-tags') || '';
          card.style.display = tags.includes(filter) ? '' : 'none';
        });
      });
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgb-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    // Support multiple slider instances on the same page
    document.querySelectorAll('[id^="testi-slider-"]').forEach(function (sliderEl) {
      var uid    = sliderEl.id.replace('testi-slider-', '');
      var track  = document.getElementById('testi-track-' + uid);
      var prevBtn = document.getElementById('testi-prev-' + uid);
      var nextBtn = document.getElementById('testi-next-' + uid);
      var dots   = sliderEl.querySelectorAll('.testi-nav__dot');

      if (!track || !track.children.length) return;

      var cards          = Array.from(track.querySelectorAll('.testi-card'));
      var totalCards     = cards.length;
      var currentIndex   = 0;
      var autoPlayTimer  = null;
      var INTERVAL       = 5000;
      var reduceMotion   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* -- How many cards visible at once -- */
      function visibleCount() {
        var w = sliderEl.offsetWidth;
        if (w < 600)  return 1;
        if (w < 900)  return 2;
        return 3;
      }

      /* -- Max index -- */
      function maxIndex() {
        return Math.max(0, totalCards - visibleCount());
      }

      /* -- Compute card width including gap -- */
      function cardWidth() {
        if (!cards[0]) return 0;
        var gap = 18;
        return (sliderEl.offsetWidth - (gap * (visibleCount() - 1))) / visibleCount() + gap;
      }

      /* -- Move to index -- */
      function goTo(i) {
        currentIndex = Math.max(0, Math.min(i, maxIndex()));
        var offset = currentIndex * cardWidth();

        if (reduceMotion) {
          track.style.transition = 'none';
        } else {
          track.style.transition = 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        }
        track.style.transform = 'translateX(-' + offset + 'px)';

        /* Update dots */
        dots.forEach(function (dot, idx) {
          var active = idx === currentIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      /* -- Auto-play -- */
      function startAutoPlay() {
        if (reduceMotion) return;
        clearInterval(autoPlayTimer);
        autoPlayTimer = setInterval(function () {
          goTo(currentIndex >= maxIndex() ? 0 : currentIndex + 1);
        }, INTERVAL);
      }

      function stopAutoPlay() {
        clearInterval(autoPlayTimer);
      }

      /* -- Controls -- */
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(currentIndex >= maxIndex() ? 0 : currentIndex + 1);
          stopAutoPlay();
          startAutoPlay(); // restart timer after manual interaction
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(currentIndex <= 0 ? maxIndex() : currentIndex - 1);
          stopAutoPlay();
          startAutoPlay();
        });
      }

      /* -- Dot navigation -- */
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-dot'), 10);
          goTo(i);
          stopAutoPlay();
          startAutoPlay();
        });
      });

      /* -- Pause on hover / focus -- */
      sliderEl.addEventListener('mouseenter', stopAutoPlay);
      sliderEl.addEventListener('mouseleave', startAutoPlay);
      sliderEl.addEventListener('focusin',    stopAutoPlay);
      sliderEl.addEventListener('focusout',   startAutoPlay);

      /* -- Touch/swipe -- */
      var touchStartX = 0;
      track.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        stopAutoPlay();
      }, { passive: true });

      track.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
        }
        startAutoPlay();
      }, { passive: true });

      /* -- Recalculate on resize -- */
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { goTo(currentIndex); }, 150);
      });

      /* -- Pause when off-screen (IntersectionObserver) -- */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            startAutoPlay();
          } else {
            stopAutoPlay();
          }
        }, { threshold: 0.3 });
        io.observe(sliderEl);
      }

      /* -- Init -- */
      goTo(0);
      startAutoPlay();
    });

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgb-usecase"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var filterBtns = document.querySelectorAll('.usecase-filter-btn');
    var cards      = document.querySelectorAll('.usecase-card');

    if (!filterBtns.length) return;

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.getAttribute('data-filter');

        filterBtns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        cards.forEach(function (card) {
          if (filter === 'all') {
            card.style.display = '';
          } else {
            var audience = card.getAttribute('data-audience') || '';
            card.style.display = audience === filter ? '' : 'none';
          }
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
